import { auth } from './firebaseAuth';

export type FeedPostEligibility = {
  canPost: boolean;
  reason: 'league' | 'match' | 'limit' | null;
  remaining: number;
};

export class FeedPostRequestError extends Error {
  status: number;

  code: string;

  constructor(status: number, code: string, message: string) {
    super(message);
    this.status = status;
    this.code = code;
  }
}

/** `/api/feed-post` istemcisi; sunucu hata kodunu (`code`) çeviri anahtarına eşlemek için döndürür. */
export async function feedPostRequest<T = { ok: boolean }>(
  method: 'GET' | 'POST' | 'DELETE',
  query: Record<string, string> = {},
  body?: object,
): Promise<T> {
  const user = auth.currentUser;
  if (!user) throw new FeedPostRequestError(401, 'AUTH', 'Giriş yapmalısın.');
  const params = new URLSearchParams(query);
  const response = await fetch(`/api/feed-post${params.toString() ? `?${params}` : ''}`, {
    method,
    cache: 'no-store',
    headers: {
      Authorization: `Bearer ${await user.getIdToken()}`,
      ...(body ? { 'Content-Type': 'application/json' } : {}),
    },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new FeedPostRequestError(response.status, String(payload?.code || ''), String(payload?.error || response.status));
  }
  return payload as T;
}

export const feedPostPhotoUrl = (postId: string) =>
  `/api/feed-post?postId=${encodeURIComponent(postId)}&photo=1`;

export const blobToBase64 = (blob: Blob) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result).replace(/^data:[^,]*,/, ''));
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(blob);
  });
